import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { CircularProgressModule } from './circular-progress/circular-progress.module';
import { CourseLogoModule } from './course-logo/course-logo.module';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { SrcsetImageModule } from './srcset-image/srcset-image.module';
import { CardModule } from './card/card.module';

@NgModule({
  imports: [
    MaterialModule,
    TranslateModule,
    CommonModule,
    CircularProgressModule,
    ProgressBarModule,
    BreadcrumbModule,
    SrcsetImageModule,
    CourseLogoModule,
    CardModule,
  ],
  declarations: [],
  exports: [
    CircularProgressModule,
    ProgressBarModule,
    BreadcrumbModule,
    SrcsetImageModule,
    CourseLogoModule,
    CardModule,
  ],
})
export class SharedModule {}
